import React, { useEffect, useState } from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';
import getDecryptData from '../../../helper/getDecryptData';
import axiosInstance from '../../../axiosInstance';

const AccountNotification = () => {

  const decryptdatajson = getDecryptData();

  const { dataAuth } = useBlogContext();

  const [Loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [Notification, setNotification] = useState([]);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: "2-digit", minute: "2-digit" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  const [sortOrder, setSortOrder] = useState(1); // 1 for Newest, 2 for Oldest
  const [filterRange, setFilterRange] = useState("all"); // 'all', 'today', '7days', '1month'

  const handleSortChange = (event) => {
    setSortOrder(parseInt(event.target.value));
  };

  const handleFilterChange = (event) => {
    setFilterRange(event.target.value);
  };

  const [formData, setFormData] = useState({
    userId: null,
    type: 0,
    note: `Add Funds By ${decryptdatajson.username} `,
    amount: 0,
    wallet: 0,
    trans: 0,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  //form handle

  const fetchnotificationById = async () => {
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson._id;

    try {
      setLoading(true);

      const { data } = await axiosInstance.get(`/all-notification?userId=${id}&type=1`);
      const { success } = data;

      if (success) {
        setNotification(data.notifications);
      }
    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
      setNotification([]);

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchnotificationById();
    dataAuth();
  }, []);

  useEffect(() => {
    if (formData.trans) {
      setNotification(Notification.reverse());
      console.log("formData.trans", formData.trans);
    }
  }, [formData.trans]);


  return (
    <>

      <HeaderPage title={'My Notification'} />



      <main className="page-content bg-white mypadding overflow-auto pb-4 px-0" >


        <div className="container pb-0 overflow-hidden">
          <div className="dz-list notification-list">
            {!Loading ? (<ul>

              {Notification.map((notification) => (
                <li key={notification._id} className="list-items ">
                  <div className="media">
                    <div className="media-20 m-r10">
                      <i className="ri-notification-fill"></i>
                    </div>
                    <div className="list-content">
                      <h5 className="title">{notification.title ?? "NA"}</h5>
                      <p className="fw-light m-0">{notification.note ?? "NA"}</p>

                      <span className="date">
                        {new Date(notification.createdAt).toLocaleDateString("en-US", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </span>
                    </div>
                  </div>
                </li>
              ))}


            </ul>) : <>
              <div
                className="skeleton mb-4 me-4"
                style={{ height: 50, width: "100%" }}
              />
              <div
                className="skeleton mb-4 me-4"
                style={{ height: 50, width: "100%" }}
              />
              <div
                className="skeleton mb-4 me-4"
                style={{ height: 50, width: "100%" }}
              />
              <div
                className="skeleton mb-4 me-4"
                style={{ height: 50, width: "100%" }}
              />
            </>}
          </div>
        </div>



        <NavBar />

      </main>
    </>
  )
}

export default AccountNotification